import { NAMESPACE } from "./_Namespace";

export class MathHelper
{
    public static classNamespace = NAMESPACE + "MathHelper";
    public static className = "MathHelper";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Public Methods

    public static clamp(x: number, lower: number, upper: number)
    {
        return x <= lower ? lower : x >= upper ? upper : x;
    }

    public static powersOfTwoToArray(value: number | null)
    {
        if (value === null)
            return [];

        const
            powers = [];

        let
            power = 0;

        while (value !== 0)
        {
            if ((value & 1) !== 0)
                powers.push(1 << power);
            ++power;
            value >>>= 1;
        }

        return powers;
    }
    public static powersOfTwoFromArray(powers: number[])
    {
        if (!powers.length)
            return null;

        let
            value = 0;

        if (powers)
            powers.forEach(item => { value += item; });

        return value;
    }

    // #endregion
}